import React, { memo } from 'react';
import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { HbtSitecoreContextType } from 'Foundation/HydrateSitecoreContext';
import HbtDashboardPlaceholderProps from './types';

const HbtDashboardPlaceHolderComponent: React.FC<HbtDashboardPlaceholderProps> = ({
  rendering
}: HbtDashboardPlaceholderProps) => {
  const sitecoreContextFactory = useSitecoreContext();

  const sitecoreContext = sitecoreContextFactory?.sitecoreContext as HbtSitecoreContextType;

  return (
    <>
      {sitecoreContext.isPortfolioSite ? (
        <Placeholder name="hbt-v2-dashboard" rendering={rendering} />
      ) : (
        <Placeholder name="hbt-dashboard" rendering={rendering} />
      )}
    </>
  );
};

export default memo(HbtDashboardPlaceHolderComponent);
